import { render } from "./CollectionDetailedSearchPrange.vue?vue&type=template&id=010b70af&scoped=true&ts=true"
import script from "./CollectionDetailedSearchPrange.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchPrange.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchPrange.vue?vue&type=style&index=0&id=010b70af&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010b70af"]])

export default __exports__